package org.chiangmeng.qfast.features.auth

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
actual fun AppleSignInButton(
    modifier: Modifier,
    enabled: Boolean,
    onTokenReceived: (idToken: String, rawNonce: String) -> Unit
) {
}
